module.exports = __webpack_public_path__ + "img/expiring_soon.f2f69fef.svg";